let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gWMGd")).then(() => parcelRequire('7V1eq'));